import LayoutsDesign from './LayoutsDesign'
import LayoutsDesignDisplay from './LayoutsDesignDisplay'

export {
  LayoutsDesign,
  LayoutsDesignDisplay
}
